<template>


<v-card
height="90%"
width="97%"
class="ma-3"
flat
>
<main-table @selectionChanged="handleSelectionChange"  @sh="showBottomSheet()" ref="childComponent"></main-table>
       <v-btn
       ref="bottomSheetBtn"
    color="primary"
    elevation="2"
    fab
    large
    right
    fixed
    plain
    bottom
    @click="showBottomSheet()"
    > 
      <v-icon>
        mdi-tools
      </v-icon>
    </v-btn>
  <BottomActionSheet 
    :selectedKiosks="selectedKiosks" 
    :show="toShow" 
    :jobsLoading="jobsLoading"
    :jobsHasMore="jobsHasMore"
    :jobsHasLoadedMore="jobsHasLoadedMore"
    :selectedFilters.sync="selectedFilters"
    @closeButtonPressed="handleCloseButtonPressed" 
    @deleteJob="deleteJobAndUpdateLastJobInDB" 
    @filterToMainBoard="handleFilter"
    @loadMoreJobs="loadMoreJobs"/>
   
</v-card>




</template>
<script>

import BottomActionSheet from '@/components/BottomActionSheet'
import MainTable from '../components/MainTable.vue'
import { store } from "@/models/Store.js";
import { deleteJob, getJobsForKiosk } from "@/services/RequestService";
//import { get } from 'mongoose';


export default {
  name: 'MainBoard',
  components: {BottomActionSheet,
    MainTable
  },
  // async beforeCreate() {
  //   store.firstCallAndLaunchIntervals();
  // },
  data:()=>({
    toShow :false, 
    selectedKiosks:[],
    currentJobFilter: {
      types: [],
      limit: 20,
      skip: 0,
    },
    selectedFilters: [],
    jobsHasMore: true,
    jobsLoading: false
  }), 
  computed: {
    jobsHasLoadedMore() {
        return this.currentJobFilter.skip > 0;
    }
  },
  mounted(){


  window.addEventListener("keydown", e => {
		if(e.code == 'Space' && e.ctrlKey){
      this.triggerButton();
    }
  });

  // to avoid space to trigger action button without ctrl key
  window.addEventListener("keyup", e=>{
    if(e.code == 'Space'){
      e.preventDefault();
    }
  })
  },

  methods:{
    async deleteJobAndUpdateLastJobInDB(item) {
      await deleteJob(item);
      await store.updateCheckHistoryList();
    },
    handleSelectionChange: function(dat){
      this.selectedKiosks = dat
    },


    triggerButton: function(){
      this.toShow = ! this.toShow;
    },
    handleCloseButtonPressed: function () {
      this.toShow=false;
      this.$refs.childComponent.$emit('custom-event');

      // Reset filtre à la fermeture
      this.selectedFilters = [];
      this.currentJobFilter = { types: [], limit: 20, skip: 0 };
      this.jobsHasMore = true;
  
  }, 
    showBottomSheet: async function () {
      if (store.state.selectedKiosks.length === 0) return;

      // Reset filtre à l'ouverture (au cas où le close n'aurait pas fait son boulot)
      this.selectedFilters = [];
      this.currentJobFilter = { types: [], limit: 20, skip: 0 };
      this.jobsHasMore = true;
      if (store.state.selectedKiosks.length < 2) {
        await store.updateCheckHistoryList();
      }
      
      this.toShow=true;
    }, 
    async handleFilter(selectedTypes) {
      const kiosk = store.state.selectedKiosks[0];
      if (!kiosk) return;

      this.currentJobFilter.types = selectedTypes || [];
      this.currentJobFilter.skip = 0;
      this.jobsHasMore = true;

      await this.fetchJobs({ append: false });
    },

    /**
     * Récupère une page de jobs filtrée depuis l'API.
     * @param {boolean} append - true pour "Charger plus", false pour remplacer la liste
     */
    async fetchJobs({ append = false } = {}) {
        const kiosk = store.state.selectedKiosks[0];
        if (!kiosk) return;

        this.jobsLoading = true;
        try {
            const { types, limit, skip } = this.currentJobFilter;
            // Récupère une page pour chaque type sélectionné, ou une seule "tous"
            const jobs = await getJobsForKiosk({
              ownerKiosk: kiosk.name,
              types: types.length > 0 ? types : undefined,
              limit,
              skip
            });

            const updatedKiosk = { ...kiosk };
            if (!updatedKiosk.jobsFlag) updatedKiosk.jobsFlag = {};

            updatedKiosk.jobsFlag.jobs = append
                ? [...(updatedKiosk.jobsFlag.jobs || []), ...jobs]
                : jobs;

            store.state.selectedKiosks = [updatedKiosk, ...store.state.selectedKiosks.slice(1)];

            this.jobsHasMore = jobs.length === limit;
        } finally {
            this.jobsLoading = false;
        }
    },

    /**
     * Helper : si plusieurs types sélectionnés, on fait un appel par type en parallèle
     * puis on fusionne et on trie par date.
     */
    async fetchJobsForCurrentFilter(ownerKiosk) {
      const { types, limit, skip } = this.currentJobFilter;

      if (!types.length) {
        return await getJobsForKiosk({ ownerKiosk, limit, skip });
      }

      const results = await Promise.all(
        types.map(type => getJobsForKiosk({ ownerKiosk, type, limit, skip }))
      );
      const merged = results.flat();
      merged.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      return merged.slice(0, limit);
    },
    async loadMoreJobs() {
      if (!this.jobsHasMore || this.jobsLoading) return;
      this.currentJobFilter.skip += this.currentJobFilter.limit;
      await this.fetchJobs({ append: true });
    }
  }
}
</script>
